import React, { useState } from "react";
//import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom"; 
import { Button } from 'react-bootstrap';

import Table from 'react-bootstrap/Table';

import "./Mobilestyles.css";

const data = [
  {
    ProjectName: "VASAVI KURMIDDA",
    LayoutArea: "Ac 7.9 CENTS",
    OpenSpace: "Ac 0.79 CENTS",
    RoadsArea: "Ac 2.494 CENTS",
    PlottedArea: "Ac 4.616 CENTS",
    NoPlots: "101",
    MortgageArea: "Ac 0.740 CENTS",
    Approvals: "T.L.P.NO 368/2022/H",
    SurveyNos: "332/PART"

  }

];

export default function Alert() {
  const [show, setShow] = useState(true);
  const [selectedData, setSelectedData] = useState({});
  const handleClick = (selectedRec) => {
    setSelectedData(selectedRec);
    setShow(true);
  };

  const hideModal = () => {
    setShow(false);
  };

  return (
    <div className="App">
      {/* {show && <Modal details={selectedData} handleClose={hideModal} />} */}
      { show && <Modal handleClose={hideModal} /> }
    </div>
  );
}

const Modal = ({ handleClose, details }) => {
  return (
    <div className="modal display-block">
      <section className="mobile-modal-main">
        <div className="App">
          <Table striped hover responsive className="tableclass">
            <thead>
              <tr className="trclass">
                <th scope="col">Project Name</th>
                <th scope="col">Layout Area</th>
                <th scope="col">Open Space (10%)</th>
                <th scope="col">Roads Area (31.57%)</th>
                <th scope="col">Plotted Area (58.43%)</th>
                <th scope="col">No. Plots</th>
                <th scope="col">Mortgage Area (16.03%)</th>
                <th scope="col">Approvals</th>
                <th scope="col">Survey Nos</th>
              </tr>
            </thead>
            <tbody className="tbodyclass">
              <tr className="trclass">
                <td>{data[0].ProjectName}</td>
                <td>{data[0].LayoutArea}</td>
                <td>{data[0].OpenSpace}</td>
                <td>{data[0].RoadsArea}</td>
                <td>{data[0].PlottedArea}</td>
                <td>{data[0].NoPlots}</td>
                <td>{data[0].MortgageArea}</td>
                <td>{data[0].Approvals}</td>
                <td>{data[0].SurveyNos}</td>
              </tr>
            </tbody>
          </Table>
        </div>
        {/* <Button type="button" class="btn btn-primary btn-sm" onClick={handleClose}>close</Button> */}
 
        <Button className="button-block" variant="secondary" size="sm" onClick={handleClose}>close</Button>

  
      </section>
    </div>
  );
};
